import React from 'react';
import { ConfirmationPopup } from './ConfirmationPopup';
import { AlertPopup } from './AlertPopup';
import { PopupReducerState } from '../../store/popup';

export function PopupRenderer({
  isOpen,
  componentName,
  componentProps,
}: PopupReducerState) {
  if (isOpen) {
    switch (componentName) {
      case 'ConfirmationPopup':
        return <ConfirmationPopup {...componentProps} />;
      case 'AlertPopup':
        return <AlertPopup {...componentProps} />;
      default:
        return null;
    }
  }

  return null;
}
